import CustomImage from "components/atoms/Image/CustomImage";
import { IVenue } from "./venusesSection";
import { useLang } from "hooks/useLang";
import { useRouter } from "next/router";

const VenueComponent = ({
  name_ar,
  name_en,
  city,
  coordinates,
  country,
  address_ar,
  address_en,
  _id

}: IVenue) => {
  const { lang, t } = useLang();
  const router = useRouter(); // Add useRouter here

  const name = lang === "ar" ? name_ar : name_en;
  const address = lang === "ar" ? address_ar : address_en;

  return (
    <div
      className="cursor-pointer bg-[#FFFFFFB2] backdrop-blur-[10px] h-[90px] rounded-[10px] flex flex-row p-2"
      onClick={() => router.push(`/venue/${_id}`)} // example navigation
    >
      <div className="w-[30%] items-center flex rounded-[6px] overflow-hidden">
        <CustomImage
          src={""}
          width={200}
          height={200}
          className="w-full h-full aspect-square"
          alt={name}
        />
      </div>
      <div className="w-[70%] flex flex-col justify-center p-3 gap-1">
        <span className="text-sm capitalize font-bold">{name}</span>
        <p className="text-xs text-[#fff]">{`${t(city!)}, ${t(country!)}`}</p>
      </div>
    </div>
  );
};

export default VenueComponent;
